import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export interface TotalHerbicidesData {
  without_cromai: number
  with_cromai: number
}

export interface RecentDiagnosisData {
  demand_id: string
  demand_name: string
  herbicides_per_diagnosis: {
    with_cromai: number
    without_cromai: number
  }
}

export interface HerbicideEconomyResponse {
  economy_metrics: {
    reduction_percentage_herbicides: string
    reduction_in_herbicides: string
    herbicides_per_ha: string
    diagnoses_per_period: number
  }
  total_herbicides_per_period: TotalHerbicidesData[]
  recent_diagnoses_spending: RecentDiagnosisData[]
}

export type PeriodType = '15' | '30' | '60' | '90' | '120'

export async function getHerbicidesEconomy(
  period: PeriodType,
  options?: AxiosRequestConfig,
) {
  const { data } = await companiesApi.get<HerbicideEconomyResponse>(
    apiRoutes.getHerbicideEconomy,
    {
      ...options,
      params: {
        period,
      },
    },
  )

  return data
}
